export const hasOnlyAsciiChars = (arg: string) => arg.replace(/[^\x00-\x7F]/g, "") === arg;
